import React, { useEffect, useState } from "react";
import { Button, Typography, Card, Box, Grid, Container, FormControl, Select, CardContent, Chip } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { Dialog, DialogContent, IconButton, List, ListItem, ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';
import { Star, CheckBox, FiberManualRecord, FormatListNumbered } from '@material-ui/icons';
import FilterListIcon from '@material-ui/icons/FilterList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SchoolIcon from '@material-ui/icons/School';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import LinkIcon from '@material-ui/icons/Link';

//  import { useNavigate } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import LessonService from "./Locality/Service/lessonService";

import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflow: "auto",
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.9rem',
    color: '#1a1a1a',
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: '#555',
    fontSize: '0.9rem',
    marginTop: 2,
  },
  noteBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#e6e6e6',
    border: '1px solid #d6e4ff',
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1a1a1a',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  filtersRow: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    width: '100%',
  },
  filtersChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    height: 38,
    boxSizing: 'border-box',
    padding: '0 12px',
    borderRadius: 999,
    border: '1px solid #8f8f8f',
    backgroundColor: '#fff',
    cursor: 'pointer',
    fontWeight: 600,
    color: '#1a1a1a',
    userSelect: 'none',
    flexShrink: 0,
  },
  countBadge: {
    backgroundColor: '#fff',
    color: '#1a1a1a',
    border: '1px solid #c4c4c4',
    borderRadius: 12,
    padding: '1px 10px',
    fontSize: '0.72rem',
    fontWeight: 700,
    marginLeft: 8,
  },
  fieldLabel: {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#444',
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    minHeight: 18,
    lineHeight: '18px',
  },
  filterFieldWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 1 220px',
    minWidth: 150,
    maxWidth: 240,
  },
  filterActionsWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto',
    justifyContent: 'flex-end',
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: 14,
    border: '1px solid #d9d9d9',
    boxShadow: 'none',
  },
  filterGrid: {
    margin: 0,
  },
  filterItem: {
    paddingTop: theme.spacing(1),
  },
  detailTitle: {
    fontWeight: 700,
    color: '#1a1a1a',
    fontSize: '1.3rem',
    marginBottom: theme.spacing(2),
  },
  sectionCard: {
    borderRadius: 14,
    border: '1px solid #d9d9d9',
    boxShadow: 'none',
    marginBottom: theme.spacing(2),
    height: '100%',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(1.5),
  },
  sectionIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  sectionTitle: {
    fontWeight: 700,
    color: '#1a1a1a',
    fontSize: '1.02rem',
  },
  bulletText: {
    color: '#444',
    fontSize: '0.92rem',
  },
  stepNumber: {
    width: 26,
    height: 26,
    borderRadius: '50%',
    backgroundColor: '#1a1a1a',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    fontWeight: 700,
  },
  poiItem: {
    padding: theme.spacing(1.25, 2),
    backgroundColor: '#e6f7ed',
    border: '1px solid #b7e3c8',
    borderRadius: 10,
    color: '#1a1a1a',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
  },
  lessonGrid: {
    marginTop: theme.spacing(2),
  },
  lessonCardItem: {
    marginBottom: theme.spacing(3),
  },
  lessonCard: {
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    transition: "0.3s",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
    },
  },
  lessonCardContent: {
    padding: theme.spacing(2.5),
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  chipWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  lessonTitle: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    lineHeight: 1.3,
  },
  watchVideoBtn: {
    marginTop: theme.spacing(2),
    backgroundColor: "#1a1a1a",
    color: "white",
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#125bbd",
    },
  },
  resultsSection: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
}));

export default function TeacherLesson(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [studentList, setStudentList] = useState([]);
  const [lessonList, setLessonList] = useState([]);
  const [dropDownList, setDropDownList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);

  var [classId, setClassId] = useState("");
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedLessonId, setSelectedLessonId] = useState("");
  var [error, setError] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [showlessons, setShowLessons] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [openImage, setOpenImage] = useState(null);
  // ---- Redesigned UI state ----
  const [filtersOpen, setFiltersOpen] = useState(false);

  const [selectedData, setSelectedData] = useState({
    _id: "",
    lesson: "",
    subjectId: '',
    pointOfInterest: [],
    stepsAndProcedures: [],
    controlOfError: [],
    materialRequired: [],
    objectives: []
  });


  // const navigate = useNavigate();


  useEffect(() => {
    //getLessonList();
    loadSubjectOptions();
    getAddClassList();
    //getLessonLists();
    return () => {
      setLessons([]);
      setSubjectOptions([]);
      // setLessonss([]);

    }
  }, []);
    const getAddClassList = (event) => {
          const userDetails = JSON.parse(localStorage.getItem("userDetail"));
          AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
              setAddClassList(res);
              if (userDetails.classId) {
                const teacherClassId = userDetails.classId?._id || userDetails.classId;
                setClassId(teacherClassId);
                loadSectionList(teacherClassId, userDetails);
                loadSubjectOptions(teacherClassId);
              } else {
                setClassId("");
              }
          }).catch((err) => {
              // setError(err.message);
          });
      }

  const loadSectionList = (nextClassId, userDetailsOverride = null) => {
    if (!nextClassId) {
      setSectionList([]);
      return;
    }
    const userDetails = userDetailsOverride || JSON.parse(localStorage.getItem("userDetail") || "{}");
    const schooleId = userDetails?.schooleId?._id || userDetails?.schooleId;
    SectionService.findSectionList({ schooleId, classId: nextClassId, status: true })
      .then((res) => {
        const list = Array.isArray(res) ? res : [];
        setSectionList(list);
        if (userDetails.role === "TEACHER" && userDetails.sectionId) {
          setSelectedSectionId(userDetails.sectionId?._id || userDetails.sectionId);
        }
      })
      .catch(() => {
        setSectionList([]);
      });
  };

  const loadSubjectOptions = (scopeClassId = null) => {
    const body = {};
    if (scopeClassId) {
      body.classId = scopeClassId;
    }
    LessonService.findLessonList(body).then((res) => {
      const rows = Array.isArray(res) ? res : [];
      const subjects = Array.from(
        new Set(
          rows
            .map((row) => getSubjectLabel(row))
            .filter((subject) => subject && subject !== 'N/A')
        )
      ).sort((a, b) => a.localeCompare(b));
      setSubjectOptions(subjects);
    }).catch(() => {
      setSubjectOptions([]);
    });
  }
  const getLessonList = (subject = null, classId = null, sectionId = null) => {
    const body = {};
    if (subject) {
      body.subject = subject;
    }
    if (classId) {
      body.classId = classId;
    }
    if (sectionId) {
      body.sectionId = sectionId;
    }

    LessonService.findLessonList(body).then((res) => {
      const rows = Array.isArray(res) ? res : [];
      setLessons(rows);
      setDropDownList(rows);
      setShowLessons(true);
    }).catch((err) => {
      setError(err.message);
    });
  }

  useEffect(() => {
    getLessonList(selectedSubject, classId, selectedSectionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classId, selectedSectionId, selectedSubject]);

  const getSectionName = (lessonRow) => {
    if (!lessonRow?.sectionId) return 'All Sections';
    if (typeof lessonRow.sectionId === 'object') {
      return lessonRow.sectionId.sectionName || 'All Sections';
    }
    return 'All Sections';
  };

  const getSubjectLabel = (lessonRow) => {
    if (lessonRow?.subject) return lessonRow.subject;
    if (lessonRow?.subjectId && typeof lessonRow.subjectId === 'object') {
      return lessonRow.subjectId.subject || 'N/A';
    }
    return 'N/A';
  };

  // const handleLearnMore = () => {
  //   //navigate(`/lessonmore/${lesson._id}`);
  // };
  const handleLearnMore = () => {
    props.history.push('/app/learnmore')
  };
  const activeFilterCount = [classId, selectedSectionId, selectedSubject, selectedLessonId].filter(Boolean).length;
  return (
    <>
      {/* Page header */}
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Lesson Plan</Typography>
          <Typography className={classes.pageSubtitle}>
            Browse lesson plans by class and subject, then open one for full details.
          </Typography>
        </Box>
      </Box>



      {/* Filters card */}
      <Card className={classes.filterCard} elevation={0}>
        <Box className={classes.filtersRow}>
          <Box
            className={classes.filtersChip}
            onClick={() => setFiltersOpen((o) => !o)}
            role="button"
            tabIndex={0}
          >
            <FilterListIcon fontSize="small" />
            <span>Filters</span>
            <span className={classes.countBadge}>{activeFilterCount}</span>
            {filtersOpen ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
          </Box>

          {filtersOpen && (
            <>
              <Box className={classes.filterFieldWrap}>
                <Typography className={classes.fieldLabel}>
                  <SchoolIcon style={{ fontSize: 16 }} /> Class
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    displayEmpty
                    name="classId"
                    onChange={(e) => {
                      const nextClassId = e.target.value;
                      setClassId(nextClassId);
                      setSelectedSectionId("");
                      loadSectionList(nextClassId);
                      loadSubjectOptions(nextClassId);
                    }}
                    value={classId}
                  >
                    <MenuItem value=""><em>All Classes</em></MenuItem>
                    {addClassList.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box className={classes.filterFieldWrap}>
                <Typography className={classes.fieldLabel}>
                  <FormatListNumbered style={{ fontSize: 16 }} /> Section
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth disabled={!classId}>
                  <Select
                    displayEmpty
                    name="sectionId"
                    value={selectedSectionId}
                    onChange={(e) => setSelectedSectionId(e.target.value)}
                  >
                    <MenuItem value=""><em>All Sections</em></MenuItem>
                    {sectionList.map(({ _id, sectionName }) => (
                      <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box className={classes.filterFieldWrap}>
                <Typography className={classes.fieldLabel}>
                  <MenuBookIcon style={{ fontSize: 16 }} /> Subject
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    displayEmpty
                    name="subject"
                    value={selectedSubject}
                    onChange={(e) => setSelectedSubject(e.target.value)}
                  >
                    <MenuItem value=""><em>All Subjects</em></MenuItem>
                    {subjectOptions.map((subject) => (
                      <MenuItem key={subject} value={subject}>{subject}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box className={classes.filterFieldWrap}>
                <Typography className={classes.fieldLabel}>
                  <FormatListNumbered style={{ fontSize: 16 }} /> Lesson
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    displayEmpty
                    name="lessonId"
                    value={selectedLessonId}
                    onChange={(e) => setSelectedLessonId(e.target.value)}
                  >
                    <MenuItem value=""><em>All Lessons</em></MenuItem>
                    {dropDownList.map(({ index, _id, lesson }) => (
                      <MenuItem key={index} value={_id}>{lesson}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </>
          )}
        </Box>
      </Card>

      <Container sx={{ py: 5 }}>



        <Grid container spacing={4} className={classes.lessonGrid}>
          {showlessons && lessons
            .filter((lesson) =>
              lesson.lesson.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .filter((lesson) => !selectedLessonId || String(lesson._id) === String(selectedLessonId))
            .map((lesson) => {
              const {
                _id,
                images,
                lesson: title,
                objectives,
                video,
                subjectId,
                classId,
                remarks,
                materialRequired
              } = lesson;
              const isSelected = selectedData._id === _id;

              return (
                <Grid item xs={12} sm={6} md={4} key={_id} className={classes.lessonCardItem}>
                  <Card
                    className={classes.lessonCard}
                    onClick={() => setSelectedData(lesson)}
                    style={{
                      boxShadow: isSelected ? '0 6px 20px rgba(23,105,214,0.22)' : undefined,
                      border: isSelected ? '2px solid #1a1a1a' : '1px solid #d9d9d9',
                      borderRadius: 14,
                      cursor: 'pointer',
                      backgroundColor: isSelected ? '#e6e6e6' : '#fff',
                    }}
                  >
                    <CardContent className={classes.lessonCardContent}>
                      <Box className={classes.chipWrapper}>
                        <Chip
                          label={classId?.className || "N/A"}
                          color="primary"
                          size="small"
                        />
                        <Chip
                          label={getSectionName(lesson)}
                          size="small"
                          style={{
                            backgroundColor: '#f3e8ff',
                            color: '#6b21a8',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                          }}
                        />
                        <Chip
                          label={getSubjectLabel(lesson)}
                          size="small"
                          style={{
                            backgroundColor: '#e3f2fd',
                            color: '#0d47a1',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                          }}
                          icon={<span role="img" aria-label="subject">📚</span>}
                        />
                      </Box>

                      <Typography variant="h6" className={classes.lessonTitle}>
                        {title.toUpperCase() || "Untitled Lesson"}
                      </Typography>




                      {video && (
                        <Button
                          className={classes.watchVideoBtn}
                          variant="contained"
                          size="small"
                            href={video}
                            target="_blank"
                            rel="noopener noreferrer"
                          fullWidth
                        >
                          WATCH VIDEO
                        </Button>
                      )}
                    </CardContent>
                  </Card>

                </Grid>
              );
            })}
        </Grid>
        <Box py={2}>
          {selectedData._id ? <>
            <Typography className={classes.detailTitle}>{selectedData?.lesson?.toUpperCase()}</Typography>
            <Card className={classes.sectionCard} elevation={0}>
              <CardContent>
                <Box className={classes.sectionHeader}>
                  <span className={classes.sectionIcon} style={{ backgroundColor: '#e6e6e6', color: '#1a1a1a' }}>
                    <TrackChangesIcon fontSize="small" />
                  </span>
                  <Typography className={classes.sectionTitle}>Objectives / Aims</Typography>
                </Box>
                <List dense>
                  {selectedData.objectives.map((step, index) => (
                    <ListItem key={index} alignItems="flex-start" disableGutters>
                      <ListItemIcon style={{ minWidth: 28 }}>
                        <FiberManualRecord style={{ fontSize: 11, color: '#1a1a1a' }} />
                      </ListItemIcon>
                      <ListItemText primary={step} primaryTypographyProps={{ className: classes.bulletText }} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>

            </Card>


            <Grid container spacing={2}>
              {/* Materials Section */}
              <Grid item xs={12} md={6}>
                <Card className={classes.sectionCard} elevation={0}>
                  <CardContent>
                    <Box className={classes.sectionHeader}>
                      <span className={classes.sectionIcon} style={{ backgroundColor: '#e6f7ed', color: '#1f8a5b' }}>
                        <CheckBox fontSize="small" />
                      </span>
                      <Typography className={classes.sectionTitle}>Materials</Typography>
                    </Box>
                    <List dense>
                      {selectedData.materialRequired.map((step, index) => (
                        <ListItem key={index} disableGutters>
                          <ListItemIcon style={{ minWidth: 32 }}>
                            <CheckBox style={{ color: '#1f8a5b' }} />
                          </ListItemIcon>
                          <ListItemText
                            primary={step}
                            primaryTypographyProps={{
                              className: classes.bulletText,
                              style: {
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap",
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>

              {/* Point of Interest Section */}
              <Grid item xs={12} md={6}>
                <Card className={classes.sectionCard} elevation={0}>
                  <CardContent>
                    <Box className={classes.sectionHeader}>
                      <span className={classes.sectionIcon} style={{ backgroundColor: '#fff4e5', color: '#e08600' }}>
                        <Star fontSize="small" />
                      </span>
                      <Typography className={classes.sectionTitle}>Point of Interest</Typography>
                    </Box>
                    <Box mt={1} display="flex" flexDirection="column" style={{ gap: 10 }}>
                      {selectedData.pointOfInterest.map((step, index) => (
                        <Box key={index} className={classes.poiItem}>
                          <Typography variant="body2" style={{ color: '#1a1a1a' }}>
                            {step}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>



            <Card className={classes.sectionCard} elevation={0}>
              <CardContent>
                <Box className={classes.sectionHeader}>
                  <span className={classes.sectionIcon} style={{ backgroundColor: '#e6e6e6', color: '#1a1a1a' }}>
                    <FormatListNumbered fontSize="small" />
                  </span>
                  <Typography className={classes.sectionTitle}>Steps / Presentation / Procedures</Typography>
                </Box>

                <List>
                  {(Array.isArray(selectedData.stepsAndProcedures) ? selectedData.stepsAndProcedures : []).map((step, index) => (
                    <ListItem key={index} alignItems="flex-start" disableGutters>
                      <ListItemIcon style={{ minWidth: 40 }}>
                        <span className={classes.stepNumber}>{index + 1}</span>
                      </ListItemIcon>
                      <ListItemText primary={step} primaryTypographyProps={{ className: classes.bulletText }} />
                    </ListItem>
                  ))}
                </List>

                {/* Image Display (if exists) */}

              </CardContent>
            </Card>

            <Card className={classes.sectionCard} elevation={0}>
              <CardContent>
                <Box className={classes.sectionHeader}>
                  <span className={classes.sectionIcon} style={{ backgroundColor: '#fdecea', color: '#d32f2f' }}>
                    <InfoOutlinedIcon fontSize="small" />
                  </span>
                  <Typography className={classes.sectionTitle}>Control of Error</Typography>
                </Box>
                {(() => {
                  const controlItems = Array.isArray(selectedData.controlOfError)
                    ? selectedData.controlOfError
                    : selectedData.controlOfError
                      ? [selectedData.controlOfError]
                      : [];
                  if (!controlItems.length) {
                    return (
                      <Typography variant="body2" style={{ color: '#8a8a8a' }}>
                        No control of error listed for this lesson.
                      </Typography>
                    );
                  }
                  return (
                    <List dense>
                      {controlItems.map((step, index) => (
                        <ListItem key={index} alignItems="flex-start" disableGutters>
                          <ListItemIcon style={{ minWidth: 28 }}>
                            <FiberManualRecord style={{ fontSize: 11, color: '#d32f2f' }} />
                          </ListItemIcon>
                          <ListItemText
                            primary={step}
                            primaryTypographyProps={{
                              className: classes.bulletText,
                              style: { wordBreak: 'break-word', whiteSpace: 'pre-wrap' },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  );
                })()}
              </CardContent>
            </Card>

            {String(selectedData.remarks || '').trim() ? (
              <Card className={classes.sectionCard} elevation={0}>
                <CardContent>
                  <Box className={classes.sectionHeader}>
                    <span className={classes.sectionIcon} style={{ backgroundColor: '#f3e8ff', color: '#6b21a8' }}>
                      <InfoOutlinedIcon fontSize="small" />
                    </span>
                    <Typography className={classes.sectionTitle}>Remarks</Typography>
                  </Box>
                  <Typography
                    className={classes.bulletText}
                    style={{
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      color: '#1a1a1a',
                    }}
                  >
                    {String(selectedData.remarks).trim()}
                  </Typography>
                </CardContent>
              </Card>
            ) : null}

            <Card className={classes.sectionCard} elevation={0}>
              <CardContent>
                <Box className={classes.sectionHeader}>
                  <span className={classes.sectionIcon} style={{ backgroundColor: '#e6e6e6', color: '#1a1a1a' }}>
                    <LinkIcon fontSize="small" />
                  </span>
                  <Typography className={classes.sectionTitle}>Useful Links</Typography>
                </Box>

                {selectedData.images?.length > 0 ? (
                  <Box
                    mt={2}
                    display="flex"
                    flexWrap="wrap"
                    style={{ gap: 16 }}
                    justifyContent="center"
                  >
                    {selectedData.images.map((imgUrl, index) => (
                      <Box key={index} textAlign="center">
                        <img
                          src={imgUrl}
                          alt={`Lesson Visual ${index + 1}`}
                          onClick={() => setOpenImage(imgUrl)}
                          style={{
                            maxWidth: '180px',
                            height: 'auto',
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                            margin: '4px',
                            cursor: 'pointer',
                            transition: 'transform 0.2s',
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2" style={{ color: '#8a8a8a' }}>No links available.</Typography>
                )}
              </CardContent>
            </Card>

            {/* Image Zoom Dialog */}
            <Dialog
              open={Boolean(openImage)}
              onClose={() => setOpenImage(null)}
              maxWidth="md"
              fullWidth
            >
              <DialogContent style={{ position: 'relative', padding: 0 }}>
                <IconButton
                  onClick={() => setOpenImage(null)}
                  style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 10,
                    backgroundColor: 'rgba(255,255,255,0.8)',
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <img
                  src={openImage}
                  alt="Zoomed"
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </DialogContent>
            </Dialog>

          </> : ""}

        </Box>
      </Container>

    </>
  );
}
